/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
// import { FindOneOptions, FindOptions } from './common';
import { entityService } from './services';

const pathname = '/debt-statistics';

export const DebtStatisticApi = {
  findDebtEntity: async (option: FindDebtEntityQuery) => {
    let url = `${pathname}/entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FindDebtEntityQuery {
  entityID: string;
  startedAt: string;
  finishedAt: string;
  withDay?: boolean;
  withWeek?: boolean;
  withMonth?: boolean;
  withYear?: boolean;
  type?: 'CUSTOMER' | 'SUPPLIER' | 'ALL';
  isAutoSplitTime?: boolean;
}
